export default {
	common: {
		viewMore: '查看更多'
	},
	banner: {
		title: '投资者关系',
		aboutOSL: '关于 OSL',
		subtitle: '亚洲领先的稳定币交易及支付基础设施',
		description:
			'OSL致力于在全球范围内提供合规高效的数字金融基础设施服务，让任何企业、金融机构和个人都能实现法币货币与数字资产间的无缝兑换、支付、交易与结算'
	},
	nav: {
		home: '首页',
		financials: '业绩和财务报告',
		filings: '证券公告',
		newsEvents: '新闻和活动',
		corporateGovernance: '公司治理',
		investorTools: '投资者工具'
	},
	pages: {
		home: {
			title: '首页',
			welcome: '欢迎来到投资者关系平台',
			description: '探索我们的财务信息、文件档案、新闻活动、公司治理和投资者工具。',
			stockInformation: '股票行情',
			financials: '业绩',
			news: '新闻',
			events: '活动',
			irContact: '联络投资者关系部',
			irContactSection: {
				investorContact: '投资者联系',
				investorContactDesc: '有关投资者关系的问题，可以发送邮件至 investor@coinbase.com 或点击下方按钮提交。',
				contactUs: '联系我们',
				email: '邮箱'
			}
		},
		financials: {
			title: '业绩',
			interim: '半年度',
			annual: '年度',
			announcements: '公告',
			fullReport: '完整报告',
			presentation: '演示材料',
			webcast: '网络回放'
		},
		filings: {
			title: '香港联交所公告',
			year: '年份',
			category: '事项分类(可多选)',
			pleaseSelect: '请选择',
			keyword: '关键词',
			search: '查询',
			reset: '重置',
			tableCategory: '事项分类',
			description: '描述',
			date: '日期',
			view: '查看',
			totalResults: '结果数量',
			itemsPerPage: '每页显示',
			previous: '上一页',
			next: '下一页'
		},
		newsEvents: {
			title: '新闻和活动'
		},
		news: {
			title: '新闻'
		},
		events: {
			title: '活动'
		},
		corporateGovernance: {
			title: '公司治理',
			tabs: {
				seniorManagement: '高级管理层',
				boardMembers: '董事会成员',
				corporateGovernanceFiles: '公司治理文件',
				committeesAndBoardRoles: '委员会构成'
			},
			table: {
				date: '日期',
				document: '文件',
				download: '下载'
			},
			committeesTable: {
				name: '姓名',
				auditCommittee: '审核委员会',
				nominationCommittee: '提名委员会',
				remunerationCommittee: '薪酬委员会',
				riskManagementCommittee: '风险管理委员会',
				chairman: '主席',
				member: '成员'
			},
			updateLatestFile: '更新于：{date}'
		},
		investorTools: {
			title: '投资者工具',
			tabs: {
				analystCoverage: '分析师覆盖',
				investorFAQs: '常见问题',
				investorEmailAlerts: '邮件订阅',
				investorContacts: '联系 IR'
			}
		},
		investorEmailAlerts: {
			title: '订阅至投资者邮件提醒',
			unsubscribe: '取消订阅至投资者邮件提醒',
			unsubscribeDescription:
				'若您希望取消订阅投资者邮件提醒，请在下方输入您的电子邮箱地址，系统将为您移除所有已订阅的投资者关系类邮件提醒。提交发送验证码请求后，您将在该电子邮箱中收到一封含有验证码的确认邮件。您必须点击输入并提交邮件中的验证码，方可完成取消订阅的请求。',
			required: '必填',
			privacyHint: '进一步了解我们如何保护您的信息，请参阅我们的 {link}。',
			privacyPolicy: '隐私政策',
			privacyHref: 'https://www.osl.com/hk-Hans/support/article/kA0fv00000001lhCAA',
			form: {
				email: '邮箱',
				verification: '验证码',
				sendCode: '获取验证码',
				sendCodeCountdown: '获取验证码({seconds}s)',
				events: '投资者提醒选项',
				unsubscribe: '取消订阅',
				submit: '提交'
			},
			placeholders: {
				email: '请输入您的邮箱地址',
				verificationCode: '请输入验证码'
			},
			validation: {
				emailRequired: '请输入邮箱地址',
				emailInvalid: '请输入有效的邮箱地址',
				verificationCodeRequired: '请输入验证码',
				subscribeRequired: '请至少选择一项订阅内容'
			},
			submitSuccess: '订阅成功！',
			unsubscribeSuccess: '取消订阅成功！',
			unsubscribeFailed: '您还未订阅，无法取消订阅',
			subscribeFailed: '邮箱已订阅，请勿重复订阅',
			sendCodeTooFrequent: '验证码发送过于频繁，请稍候再试'
		},
		investorContacts: {
			form: {
				firstName: '名字',
				lastName: '姓氏',
				email: '邮箱',
				phone: '电话',
				question: '问题',
				submit: '提交',
				reset: '重置'
			},
			placeholders: {
				firstName: '请输入您的名字',
				lastName: '请输入您的姓氏',
				email: '请输入您的邮箱',
				phone: '请输入您的电话',
				question: '请输入您的问题或留言',
				customField: '请输入{name}'
			},
			validation: {
				firstNameRequired: '请输入您的名字',
				lastNameRequired: '请输入您的姓氏',
				emailRequired: '请输入您的邮箱',
				emailInvalid: '请输入有效的邮箱地址',
				phoneRequired: '请输入您的电话',
				questionRequired: '请输入您的问题或留言',
				customFieldRequired: '请输入{name}'
			},
			submitSuccess: '提交成功，感谢您的关注和建议！'
		},
		analystCoverage: {
			table: {
				company: '机构',
				analysts: '分析师',
				email: '电子邮箱'
			}
		},
		investorFAQs: {
			displayAll: '展开全部',
			hideAll: '收起全部'
		},
		notFound: {
			message: '页面未找到',
			backBtn: '返回首页'
		},
		common: {
			viewMore: '查看更多'
		}
	},
	language: {
		select: '选择语言',
		english: 'English',
		simplified: '中文(简体)',
		traditional: '中文(繁體)'
	},
	footer: {
		columns: {
			company: '公司',
			individual: '个人',
			enterprise: '企业',
			community: '社区',
			buyCrypto: '买数字资产',
			help: '帮助',
			legal: '法律'
		},
		company: {
			aboutUs: '关于我们',
			team: '团队',
			investorOverview: '投资者概览',
			joinUs: '加入我们',
			marketFocus: '市场焦点',
			blog: 'OSL 博客',
			mediaCoverage: '媒体报道',
			cryptoEncyclopedia: '币懂百科',
			announcement: '公告中心'
		},
		individual: {
			flashTrade: '闪电交易',
			privateClients: '私人客户',
			proTrade: '专业交易',
			recurringBuy: '定投'
		},
		enterprise: {
			proTrade: '专业交易',
			otc: '场外交易',
			custody: '托管',
			staking: '质押服务',
			wealthManagement: '财富管理',
			rwa: 'RWA',
			omnibus: 'Omnibus',
			stablex: 'StableX',
			api: 'API'
		},
		community: {
			emailPrompt: '输入您的电邮地址以接收来自 OSL 及其母公司 (OSL集团) 的讯息和更新',
			emailPlaceholder: '输入您的电子邮箱',
			emailConsent: '输入您的电子邮件即表示您承认并同意 OSL 根据隐私政策收集和使用您的个人数据。',
			downloadApp: '下载 App'
		},
		buyCrypto: {
			buyBitcoin: '买 比特币',
			buyEthereum: '买 以太坊',
			productDisclosure: '产品披露'
		},
		help: {
			supportCenter: '帮助中心',
			fees: '费用',
			contactUs: '联系我们'
		},
		legal: {
			terms: '条款及细则',
			riskDisclosure: '风险披露',
			tokenRules: '代币上架和移除规则',
			tradingRules: '交易规则',
			privacyPolicy: '隐私政策'
		},
		copyright: {
			rights: '© OSL 版权所有。',
			disclaimer1: '本网站涉及数字资产交易，可能包括数字证券和其他复杂金融产品或工具，可能不适合所有投资者。',
			disclaimer2: '本网站不构成任何数字资产或金融工具交易的招揽、邀请或要约。'
		}
	},
	stock: {
		hkStockExchange: '香港联交所',
		tips: '至少延迟 15 分钟。来源：进门',
		hkt: 'HKT'
	}
};
